export default __webpack_public_path__ + "static/media/soccer.0cb3647e.gif";